export const Version = () => {
  return (
    <div>
      <p>GitHub SHA: {import.meta.env.VITE_GITHUB_SHA}</p>
    </div>
  );
};
